// extracted by mini-css-extract-plugin
export default {"network":"FooterSocialNetwork_network__72lzw"};